/* eslint-disable react/react-in-jsx-scope */
import {
  Briefcase,
  Building,
  BuildingIndustries,
  BuildingSkyscrappers,
  Calendar,
  Cash,
  ChartLine,
  Crown,
  DisplayStar,
  Hotspot,
  LinkedinSquare,
  MapPin,
  Microchip,
  News,
  Search,
  Share,
  Users,
  UserStar,
  Wallet,
  World,
} from '@saleshandy/icons';
import { FilterComponentType } from '../types';
import {
  INDUSTRY_DATA,
  LOCATION_DATA,
  EMPLOYEE_COUNT_DATA,
  COMPANY_RANGE_SMALL_DATA,
  COMPANY_JOB_OPENING_RANGE_DATA,
  COMPANY_LINKEDIN_FOLLOWERS_RANGE_DATA,
  COMPANY_WEBSITE_VISITORS_RANGE_DATA,
  COMPANY_REVENUE_RANGE_DATA,
  COMPANY_FUNDING_AMOUNT_RANGE_DATA,
  COMPANY_FUNDING_ROUND_DATA,
  COMPANY_FUNDING_DATE_DATA,
  COMPANY_REVIEW_SCORE_BUCKET_DATA,
  COMPANY_REVIEW_COUNT_BUCKET_DATA,
  // COMPANY_TYPE_DATA,
  // COMPANY_CURRENCY_DATA,
  COMPANY_PERCENTAGE_RANGE_DATA,
  SENIORITY_GROUP_OPTIONS,
  DEPARTMENT_GROUP_OPTIONS,
  YEARS_OF_EXPERIENCE_DATA,
  SCORE_CHANGE_RANGE_DATA,
  SCORE_CHANGE_DURATION_DATA,
  SCORE_CHANGE_DIRECTION_DATA,
  PROJECTED_BASE_SALARY_DATA,
} from './filter-data';
import { Placement } from '../../../shared/design-system/components/overlay';

// Company-specific filter configuration
export const COMPANY_FILTER_LIST: any = [
  {
    id: 'filter-company-list',
    key: 'company_list',
    label: 'Company List',
    group: 'List Inclusion / Exclusion',
    icon: <Building />,
    type: [
      {
        id: 'filter-company-list-checkbox',
        key: 'company_list',
        excludeKey: 'excludeCompany_list',
        value: FilterComponentType.COMPANY_LIST,
        inputPlaceHolder: 'Select lists',
        includeMaxLimit: 50,
        maxTotalLimit: 50,
        expandedMaxFilterTags: 5,
      },
    ],
  },
  {
    id: 'filter-company-name',
    key: 'company_name',
    label: 'Company Name',
    group: 'Company Basics',
    icon: <Building />,
    type: [
      {
        id: 'filter-company-name-checkbox',
        key: 'company_ids',
        value: FilterComponentType.MULTILEVEL_CHECKBOX,
        inputPlaceHolder: 'Enter Company Name',
        includeMaxLimit: 100,
        expandedMaxFilterTags: 5,
        enableBulkSearch: true,
        bulkSearchKey: 'company_name',
        // disableCustomInput: true,
        // hideIncludeExclude: false,
      },
    ],
  },
  {
    id: 'filter-company-domain',
    key: 'company_domain',
    label: 'Company Domain',
    group: 'Company Basics',
    icon: <World />,
    type: [
      {
        id: 'filter-company-domain-checkbox',
        key: 'company_domain',
        value: FilterComponentType.MULTILEVEL_CHECKBOX,
        inputPlaceHolder: 'Enter Company Domain',
        includeMaxLimit: 100,
        expandedMaxFilterTags: 5,
        enableBulkSearch: true,
        bulkSearchKey: 'company_domain',
        // disableCustomInput: true,
        // hideIncludeExclude: true,
      },
    ],
  },
  // {
  //   id: 'filter-company-domain',
  //   key: 'company_domain',
  //   label: 'Company Domain',
  //   group: 'Company Basics',
  //   icon: <Building />,
  //   type: [
  //     {
  //       id: 'filter-company-domain-checkbox',
  //       key: 'company_domain',
  //       value: FilterComponentType.MULTILEVEL_CHECKBOX,
  //       inputPlaceHolder: 'Search and Select',
  //       includeMaxLimit: 100,
  //       expandedMaxFilterTags: 5,
  //       enableBulkSearch: true,
  //       bulkSearchKey: 'company_domain',
  //       disableCustomInput: true,
  //       hideIncludeExclude: true,
  //     },
  //   ],
  // },
  {
    id: 'filter-hq-location',
    key: 'company_hq_location',
    label: 'Company Location',
    group: 'Company Basics',
    icon: <MapPin />,
    type: [
      {
        id: 'filter-hq-location-checkbox',
        key: 'company_hq_location',
        excludeKey: 'excludeCompany_hq_location',
        value: FilterComponentType.MULTILEVEL_CHECKBOX,
        inputClassName: 'location-input mb-0',
        inputPlaceHolder: 'Enter location',
        includeMaxLimit: 100,
        list: LOCATION_DATA,
        advanceFilters: {
          showExactMatchCheckbox: true,
        },
      },
    ],
  },
  {
    id: 'filter-founded-year',
    key: 'company_founded_year',
    label: 'Founding Year',
    group: 'Company Basics',
    icon: <Calendar />,
    type: [
      {
        id: 'filter-founded-year-dropdown',
        key: 'company_founded_year',
        value: FilterComponentType.DROP_DOWN,
        placeholder: 'Select year',
        list: YEARS_OF_EXPERIENCE_DATA,
      },
    ],
  },
  {
    id: 'filter-company-industry',
    key: 'company_industry',
    label: 'Industry',
    group: 'Company Basics',
    icon: <BuildingIndustries />,
    type: [
      {
        id: 'filter-company-industry-checkbox',
        key: 'company_industry',
        excludeKey: 'excludeCompany_industry',
        value: FilterComponentType.MULTILEVEL_CHECKBOX,
        inputPlaceHolder: 'Enter industry',
        list: INDUSTRY_DATA,
        includeMaxLimit: 100,
        inputClassName: 'mb-0',
        // advanceFilters: {
        //   showExactMatchCheckbox: true,
        // },
      },
      // {
      //   id: 'filter-company-type',
      //   key: 'type',
      //   excludeKey: 'excludeType',
      //   value: FilterComponentType.MULTILEVEL_CHECKBOX,
      //   name: 'Type',
      //   inputPlaceHolder: 'Enter type',
      //   list: COMPANY_TYPE_DATA,
      //   enableBulkSearch: true,
      //   advanceFilters: {
      //     showExactMatchCheckbox: true,
      //   },
      // },
      {
        id: 'filter-company-sic-code',
        key: 'sic_codes',
        value: FilterComponentType.SEARCH_INPUT,
        name: 'SIC',
        className: 'sic-code-input',
        placeholder: 'Enter SIC Code',
        // advanceFilters: {
        //   showExactMatchCheckbox: true,
        // },
      },
      {
        id: 'filter-company-naics-code',
        key: 'naics_codes',
        value: FilterComponentType.SEARCH_INPUT,
        name: 'NAIC',
        className: 'naics-code-input',
        placeholder: 'Enter NAICS Code',
        // advanceFilters: {
        //   showExactMatchCheckbox: true,
        // },
      },
    ],
  },
  {
    id: 'filter-is-b2b',
    key: 'is_b2b',
    label: 'Company is B2B',
    group: 'Company Basics',
    icon: <Building />,
    type: [
      {
        id: 'filter-is-b2b',
        key: 'is_b2b',
        value: FilterComponentType.RADIO_BUTTON,
        name: 'Is B2B',
        className: 'is-b2b-radio-button',
        hideLabel: true,
      },
    ],
  },
  {
    id: 'filter-look-alike',
    key: 'lookalike',
    label: 'Lookalike',
    group: 'Company Basics',
    icon: <BuildingSkyscrappers />,
    type: [
      {
        id: 'filter-look-alike-name',
        key: 'competitors_company_name',
        value: FilterComponentType.MULTILEVEL_CHECKBOX,
        name: 'Company Name / Website URL',
        inputLabel: 'Company Name / Website URL',
        inputPlaceHolder: 'Enter Company Name',
        includeMaxLimit: 5,
        expandedMaxFilterTags: 5,
        hideIncludeExclude: true,
      },
      // {
      //   id: 'filter-look-alike-domain',
      //   key: 'website_domain',
      //   value: FilterComponentType.MULTILEVEL_CHECKBOX,
      //   name: 'Domain',
      //   inputLabel: 'Domain',
      //   inputPlaceHolder: 'Search and Select',
      //   includeMaxLimit: 5,
      //   expandedMaxFilterTags: 5,
      //   hideIncludeExclude: true,
      // },
    ],
  },
  {
    id: 'filter-ownership-status',
    key: 'ownership_status',
    label: 'Ownership Type',
    group: 'Company Basics',
    icon: <Crown />,
    type: [
      {
        id: 'filter-ownership-status-radio',
        key: 'ownership_status',
        value: FilterComponentType.RADIO_BUTTON,
        className: 'ownership-status-radio-button',
        hideLabel: true,
        customOptions: [
          { label: 'Private', value: 'Private' },
          { label: 'Public', value: 'Public' },
          { label: 'Other', value: 'Other' },
        ],
      },
    ],
  },
  // {
  //   id: 'filter-company-bootstrap',
  //   key: 'company_bootstrapped',
  //   label: 'Company Bootstrap',
  //   group: 'Company Basics',
  //   icon: <Building />,
  //   type: [
  //     {
  //       id: 'filter-company-bootstrap-radio',
  //       key: 'company_bootstrapped',
  //       value: FilterComponentType.RADIO_BUTTON,
  //       className: 'company-bootstrap-radio-button',
  //       hideLabel: true,
  //     },
  //   ],
  // },
  {
    id: 'filter-technologies',
    key: 'technologies_used',
    label: 'Technologies',
    group: 'Company Basics',
    icon: <Microchip />,
    type: [
      {
        id: 'filter-technologies-checkbox',
        key: 'technologies_used',
        excludeKey: 'excludeTechnologies_used',
        value: FilterComponentType.MULTILEVEL_CHECKBOX,
        inputPlaceHolder: 'Enter technologies',
        hideIncludeExclude: true,
        includeMaxLimit: 100,
        // advanceFilters: { showExactMatchCheckbox: true },
      },
    ],
  },
  {
    id: 'filter-website-url',
    key: 'website',
    label: 'Website URL',
    group: 'Online Presence',
    icon: <World />,
    type: [
      {
        id: 'filter-website-url-input',
        key: 'website',
        value: FilterComponentType.SEARCH_INPUT,
        placeholder: 'Enter Website URL',
        // advanceFilters: {
        //   showExactMatchCheckbox: true,
        // },
      },
    ],
  },
  {
    id: 'filter-linkedin-url',
    key: 'linkedin_url',
    label: 'Linkedin URL',
    group: 'Online Presence',
    icon: <LinkedinSquare />,
    type: [
      {
        id: 'filter-linkedin-url-search-input',
        key: 'linkedin_url',
        value: FilterComponentType.MULTILEVEL_CHECKBOX,
        inputPlaceHolder: 'Enter LinkedIn URL',
        name: 'LinkedIn URL',
        placeholder: 'Enter LinkedIn URL',
        includeMaxLimit: 100,
        expandedMaxFilterTags: 5,
        enableBulkSearch: true,
        bulkSearchKey: 'linkedin_url',
        hideIncludeExclude: true,
      },
    ],
  },
  {
    id: 'filter-linkedin-followers',
    key: 'followers_count_linkedin',
    label: 'Linkedin Followers',
    group: 'Online Presence',
    icon: <Users />,
    type: [
      {
        id: 'filter-followers-count-linkedin',
        key: 'followers_count_linkedin',
        // name: 'Linkedin Followers',
        value: FilterComponentType.DROP_DOWN,
        list: COMPANY_LINKEDIN_FOLLOWERS_RANGE_DATA,
      },
    ],
  },
  {
    id: 'filter-socials',
    key: 'social_urls',
    label: 'Socials',
    group: 'Online Presence',
    icon: <Share />,
    type: [
      {
        id: 'filter-social-urls-input',
        key: 'social_urls',
        value: FilterComponentType.SEARCH_INPUT,
        placeholder: 'Enter social URL',
        // advanceFilters: { showExactMatchCheckbox: true },
      },
    ],
  },
  {
    id: 'filter-revenue',
    key: 'revenue',
    label: 'Revenue',
    group: 'Financials',
    icon: <ChartLine />,
    type: [
      {
        id: 'filter-annual-revenue',
        key: 'company_annual_revenue',
        value: FilterComponentType.DROP_DOWN,
        list: COMPANY_REVENUE_RANGE_DATA,
        isPrefix: true,
      },
    ],
  },
  {
    id: 'filter-funding',
    key: 'funding',
    label: 'Funding',
    group: 'Financials',
    icon: <Cash />,
    type: [
      {
        id: 'filter-funding-rounds-name',
        key: 'funding_rounds_name',
        value: FilterComponentType.MULTILEVEL_CHECKBOX,
        name: 'Funding Round',
        inputPlaceHolder: 'Enter funding round',
        list: COMPANY_FUNDING_ROUND_DATA,
        hideIncludeExclude: true,
        inputClassName: 'funding-round-input',
        // advanceFilters: { showExactMatchCheckbox: true },
      },
      {
        id: 'filter-funding-rounds-date',
        key: 'funding_rounds_announced_date',
        value: FilterComponentType.DROP_DOWN,
        name: 'Funding Date',
        list: COMPANY_FUNDING_DATE_DATA,
        className: 'mt-2',
      },
      {
        id: 'filter-funding-rounds-amount',
        key: 'company_funding_amount',
        value: FilterComponentType.DROP_DOWN,
        name: 'Funding Amount',
        list: COMPANY_FUNDING_AMOUNT_RANGE_DATA,
        isPrefix: true,
      },
    ],
  },
  {
    id: 'filter-last-funding-round',
    key: 'last_funding',
    label: 'Last Funding Round',
    group: 'Financials',
    icon: <Cash />,
    type: [
      {
        id: 'filter-last-funding-round-name',
        key: 'last_funding_round_name',
        excludeKey: 'excludeLast_funding_round_name',
        value: FilterComponentType.MULTILEVEL_CHECKBOX,
        name: 'Last Funding Round',
        inputPlaceHolder: 'Enter funding round',
        list: COMPANY_FUNDING_ROUND_DATA,
        hideIncludeExclude: true,
        inputClassName: 'funding-round-input',
        // advanceFilters: { showExactMatchCheckbox: true },
      },
      {
        id: 'filter-last-funding-round-date',
        key: 'last_funding_round_announced_date',
        value: FilterComponentType.DROP_DOWN,
        name: 'Last Funding Date',
        list: COMPANY_FUNDING_DATE_DATA,
        className: 'mt-2',
      },
      {
        id: 'filter-last-funding-round-amount',
        key: 'last_funding_round_amount_raised',
        value: FilterComponentType.DROP_DOWN,
        name: 'Last Funding Amount',
        list: COMPANY_FUNDING_AMOUNT_RANGE_DATA,
        isPrefix: true,
      },
    ],
  },
  {
    id: 'filter-employee-count',
    key: 'company_size',
    label: 'Employee Count',
    group: 'Team & Size',
    icon: <Users />,
    type: [
      {
        id: 'filter-employee-count-dropdown',
        key: 'company_size',
        value: FilterComponentType.DROP_DOWN,
        list: EMPLOYEE_COUNT_DATA,
      },
    ],
  },
  {
    id: 'filter-seniority-wise-employee-count',
    key: 'employee_count_seniority',
    label: 'Employee Count by Designation',
    group: 'Team & Size',
    icon: <Users />,
    type: [
      {
        id: 'filter-seniority-group-dropdown',
        key: 'employee_count_seniority',
        value: FilterComponentType.GROUP_DROPDOWN,
        groupOptions: SENIORITY_GROUP_OPTIONS,
        rangeList: COMPANY_RANGE_SMALL_DATA,
        placeholder: 'Select',
      },
    ],
  },
  {
    id: 'filter-department-wise-employee-count',
    key: 'employee_count_department',
    label: 'Employee Count by Department',
    group: 'Team & Size',
    icon: <Users />,
    type: [
      {
        id: 'filter-department-group-dropdown',
        key: 'employee_count_department',
        value: FilterComponentType.GROUP_DROPDOWN,
        groupOptions: DEPARTMENT_GROUP_OPTIONS,
        rangeList: COMPANY_RANGE_SMALL_DATA,
        placeholder: 'Select',
      },
    ],
  },
  {
    id: 'filter-active-job-openings',
    key: 'active_job_postings',
    label: 'Active Job Opening For',
    group: 'Hiring & Compensation',
    icon: <Briefcase />,
    type: [
      {
        id: 'filter-active-job-postings-title',
        key: 'active_job_postings_title',
        excludeKey: 'excludeActive_job_postings_title',
        value: FilterComponentType.MULTILEVEL_CHECKBOX,
        name: 'Title',
        inputPlaceHolder: 'Enter job title',
        list: [],
        includeMaxLimit: 100,
        expandedMaxFilterTags: 5,
        hideIncludeExclude: true,
        // advanceFilters: { showExactMatchCheckbox: true },
      },
    ],
  },
  {
    id: 'filter-active-job-openings-count',
    key: 'active_job_postings_count',
    label: 'Job Opening Count',
    group: 'Hiring & Compensation',
    icon: <Briefcase />,
    type: [
      {
        id: 'filter-active-job-postings-count',
        key: 'active_job_postings_count',
        value: FilterComponentType.DROP_DOWN,
        list: COMPANY_JOB_OPENING_RANGE_DATA,
        // dependsOnKey: 'active_job_postings_title',
      },
    ],
  },
  {
    id: 'filter-salary-information',
    key: 'base_salary',
    label: 'Salary by Job Title',
    group: 'Hiring & Compensation',
    icon: <Wallet />,
    type: [
      {
        id: 'filter-base-salary-title',
        key: 'base_salary_title',
        value: FilterComponentType.GROUP_DROPDOWN,
        rangeList: PROJECTED_BASE_SALARY_DATA,
        placeholder: 'Select Job Title',
        fetchGroupOptionsFromApi: true,
        suggestionApi: { type: 'job-title' },
      },
    ],
  },
  // {
  //   id: 'filter-domain',
  //   key: 'website_domain',
  //   label: 'Domain',
  //   group: 'Domain',
  //   icon: <World />,
  //   type: [
  //     {
  //       id: 'filter-domain-input',
  //       key: 'website_domain',
  //       value: FilterComponentType.SEARCH_INPUT,
  //       name: 'Domain',
  //       placeholder: 'Domain',
  //       advanceFilters: {
  //         showExactMatchCheckbox: true,
  //       },
  //     },
  //   ],
  // },
  // {
  //   id: 'filter-website-visitor-count',
  //   key: 'website_visitor',
  //   label: 'Website visitor count by month',
  //   group: 'Website visitor count by month',
  //   icon: <World />,
  //   type: [
  //     {
  //       id: 'filter-total-website-visits-monthly',
  //       key: 'total_website_visits_monthly',
  //       value: FilterComponentType.DROP_DOWN,
  //       name: 'Website visitor',
  //       list: COMPANY_WEBSITE_VISITORS_RANGE_DATA,
  //     },
  //     ...
  //   ],
  // },
  {
    id: 'filter-last-month-website-visitors',
    key: 'total_website_visits_monthly',
    label: 'Last Month Website Visitors',
    group: 'Website Visitors',
    icon: <World />,
    type: [
      {
        id: 'filter-total-website-visits-monthly',
        key: 'total_website_visits_monthly',
        value: FilterComponentType.DROP_DOWN,
        placeholder: 'Select Visitor Range',
        list: COMPANY_WEBSITE_VISITORS_RANGE_DATA,
      },
    ],
  },
  {
    id: 'filter-global-ranking',
    key: 'rank_global',
    label: 'Global Ranking',
    group: 'Website Visitors',
    icon: <World />,
    type: [
      {
        id: 'filter-rank-global',
        key: 'rank_global',
        value: FilterComponentType.DROP_DOWN,
        placeholder: 'Select Ranking Range',
        list: COMPANY_WEBSITE_VISITORS_RANGE_DATA,
      },
    ],
  },
  {
    id: 'filter-visitor-by-gender',
    key: 'visits_breakdown_by_gender',
    label: 'Visitor share by gender (%)',
    group: 'Website Visitors',
    icon: <World />,
    type: [
      {
        id: 'filter-visits-breakdown-by-gender-type',
        key: 'visits_breakdown_by_gender_type',
        value: FilterComponentType.RADIO_BUTTON,
        name: 'Select Gender',
        customOptions: [
          { label: 'Male', value: 'male' },
          { label: 'Female', value: 'female' },
        ],
      },
      {
        id: 'filter-visits-breakdown-by-gender-range',
        key: 'visits_breakdown_by_gender_range',
        value: FilterComponentType.DROP_DOWN,
        name: 'Select Website Visitors Range',
        placeholder: 'Select Visitor Range',
        list: COMPANY_PERCENTAGE_RANGE_DATA,
        className: 'visits-breakdown-by-gender-range',
        dependsOnKey: 'visits_breakdown_by_gender_type',
      },
    ],
  },
  {
    id: 'filter-visitor-by-country',
    key: 'visits_breakdown_by_country',
    label: 'Visitor share by country (%)',
    group: 'Website Visitors',
    icon: <World />,
    type: [
      {
        id: 'filter-visits-breakdown-by-country-group-dropdown',
        key: 'visits_breakdown_by_country',
        value: FilterComponentType.GROUP_DROPDOWN,
        rangeList: COMPANY_PERCENTAGE_RANGE_DATA,
        placeholder: 'Select country',
        fetchGroupOptionsFromApi: true,
        suggestionApi: { type: 'location', paramType: 'country' },
      },
    ],
  },
  {
    id: 'filter-signals',
    key: 'signals',
    label: 'Signals',
    group: 'Signals & News',
    icon: <Hotspot />,
    type: [
      {
        id: 'filter-signals-checkbox',
        key: 'signals',
        value: FilterComponentType.MULTILEVEL_CHECKBOX,
        name: 'Signals',
        inputPlaceHolder: 'Select signals',
        list: [],
        disableCustomInput: true,
        hideSearchBox: true,
        hideIncludeExclude: true,
        inputClassName: 'mb-0',
        removeTopMargin: true,
      },
    ],
  },
  {
    id: 'filter-news',
    key: 'news',
    label: 'News',
    group: 'Signals & News',
    icon: <News />,
    type: [
      {
        id: 'filter-news-checkbox',
        key: 'news',
        value: FilterComponentType.MULTILEVEL_CHECKBOX,
        name: 'News',
        inputPlaceHolder: 'Select news',
        list: [],
        disableCustomInput: true,
        hideSearchBox: true,
        hideIncludeExclude: true,
        inputClassName: 'mb-0',
        removeTopMargin: true,
      },
    ],
  },
  {
    id: 'filter-employee-review-count',
    key: 'employee_reviews',
    label: 'Employee Review Score',
    group: 'Review and Reputation',
    icon: <UserStar />,
    type: [
      {
        id: 'filter-employee-reviews-total-count',
        key: 'employee_reviews_total_count',
        value: FilterComponentType.DROP_DOWN,
        name: 'Total Reviews',
        list: COMPANY_REVIEW_COUNT_BUCKET_DATA,
        tooltipTextInfoCircle:
          'Number of employee reviews submitted for this company.',
      },
      {
        id: 'filter-employee-reviews-aggregate-score',
        key: 'employee_reviews_aggregate_score',
        value: FilterComponentType.DROP_DOWN,
        name: 'Overall Rating',
        list: COMPANY_REVIEW_SCORE_BUCKET_DATA,
        tooltipTextInfoCircle:
          'Average employee rating across all reviews, measured on a 0–5 scale.',
      },
      {
        id: 'filter-employee-reviews-business-outlook',
        key: 'employee_reviews_business_outlook',
        value: FilterComponentType.DROP_DOWN,
        name: 'Business Outlook Rating',
        list: COMPANY_REVIEW_SCORE_BUCKET_DATA,
        tooltipTextInfoCircle:
          'Average employee rating of confidence in the company’s future performance and growth prospects.',
      },
      {
        id: 'filter-employee-reviews-ceo-approval',
        key: 'employee_reviews_ceo_approval',
        value: FilterComponentType.DROP_DOWN,
        name: 'CEO Approval Rating',
        list: COMPANY_REVIEW_SCORE_BUCKET_DATA,
        tooltipTextInfoCircle:
          'Average employee rating of approval for the CEO’s leadership.',
      },
      {
        id: 'filter-employee-reviews-career-opportunities',
        key: 'employee_reviews_career_opportunities',
        value: FilterComponentType.DROP_DOWN,
        name: 'Career Opportunities Rating',
        list: COMPANY_REVIEW_SCORE_BUCKET_DATA,
        tooltipTextInfoCircle:
          'Average employee rating of career growth, learning opportunities, and promotion potential within the company.',
      },
      {
        id: 'filter-employee-reviews-recommend',
        key: 'employee_reviews_recommend',
        value: FilterComponentType.DROP_DOWN,
        name: 'Employee Recommendation Rating',
        list: COMPANY_REVIEW_SCORE_BUCKET_DATA,
        tooltipTextInfoCircle:
          'Average employee rating of likelihood to recommend this company as a workplace.',
      },
      {
        id: 'filter-employee-reviews-work-life-balance',
        key: 'employee_reviews_work_life_balance',
        value: FilterComponentType.DROP_DOWN,
        name: 'Work–Life Balance Rating',
        list: COMPANY_REVIEW_SCORE_BUCKET_DATA,
        tooltipTextInfoCircle:
          'Average employee rating of flexibility, workload, and balance between professional and personal life.',
      },
      {
        id: 'filter-employee-reviews-culture-values',
        key: 'employee_reviews_culture_values',
        value: FilterComponentType.DROP_DOWN,
        name: 'Culture & Values Rating',
        list: COMPANY_REVIEW_SCORE_BUCKET_DATA,
        tooltipTextInfoCircle:
          'Average employee rating  of the company’s culture, ethics, inclusivity, and overall workplace environment.',
      },
    ],
  },
  {
    id: 'filter-estimated-product-review-score',
    key: 'product_reviews',
    label: 'Product Review Score',
    group: 'Review and Reputation',
    icon: <DisplayStar />,
    type: [
      {
        id: 'filter-product-reviews-count',
        key: 'product_reviews_count',
        value: FilterComponentType.DROP_DOWN,
        name: 'Total Product Review',
        list: COMPANY_REVIEW_COUNT_BUCKET_DATA,
        tooltipTextInfoCircle:
          'Number of customer reviews submitted for this product',
      },
      {
        id: 'filter-product-reviews-aggregate-score',
        key: 'product_reviews_aggregate_score',
        value: FilterComponentType.DROP_DOWN,
        name: 'Overall Product Rating',
        list: COMPANY_REVIEW_SCORE_BUCKET_DATA,
        tooltipTextInfoCircle:
          'Average customer rating across all reviews (0–5 scale)',
        dropdownPlacement: Placement.Top,
      },
    ],
  },
  {
    id: 'filter-product-review-score-change',
    key: 'product_reviews_score_change',
    label: 'Product Review Score Change',
    group: 'Review and Reputation',
    icon: <DisplayStar />,
    type: [
      {
        id: 'filter-product-reviews-score-change-monthly',
        key: 'product_reviews_score_change_duration',
        value: FilterComponentType.DROP_DOWN,
        name: 'Time Period',
        list: SCORE_CHANGE_DURATION_DATA,
      },
      {
        id: 'filter-product-reviews-score-change-quarterly',
        key: 'product_reviews_score_change_direction',
        value: FilterComponentType.DROP_DOWN,
        name: 'Score Direction',
        list: SCORE_CHANGE_DIRECTION_DATA,
      },
      {
        id: 'filter-product-reviews-score-change-yearly',
        key: 'product_reviews_score_change_points_range',
        value: FilterComponentType.DROP_DOWN,
        name: 'Score Change Range',
        list: SCORE_CHANGE_RANGE_DATA,
        dropdownPlacement: Placement.Top,
      },
    ],
  },
  {
    id: 'filter-keyword',
    key: 'keywords',
    label: 'Keywords',
    group: 'Other',
    icon: <Search />,
    type: [
      {
        id: 'filter-keyword-search',
        key: 'keywords',
        excludeKey: 'excludeCategories_and_keywords',
        value: FilterComponentType.MULTILEVEL_CHECKBOX,
        name: 'Search',
        inputPlaceHolder: 'Enter keywords',
        includeMaxLimit: 100,
        expandedMaxFilterTags: 5,
        hideIncludeExclude: true,
        // advanceFilters: { showExactMatchCheckbox: true },
      },
    ],
  },
];

export const COMPANY_FILTER_GROUP_ORDER = [
  'List Inclusion / Exclusion',
  'Company Basics',
  'Online Presence',
  'Team & Size',
  'Financials',
  'Hiring & Compensation',
  'Domain',
  'Website Visitors',
  'Signals & News',
  'Review and Reputation',
  'Technology Stack',
  'Other',
];
